
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CartButton',
  data: () => ({
    cartHint: false
  }),
  computed: {
    ...mapGetters('cart', ['itemsCount'])
  },
  watch: {
    itemsCount(count) {
      if (count === 0) {
        this.cartHint = false
      } else {
        this.cartHint = true
        setTimeout(() => {
          this.cartHint = false
        }, 5000)
      }
    }
  },
  methods: {
    ...mapActions(['openCart'])
  }
}
